import { NgModule } from "@angular/core";

import { AnimateDialogHeightResizeDirective } from "./animate-dialog-height-resize.directive";

const DIRECTIVES = [AnimateDialogHeightResizeDirective];

@NgModule({
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class AnimateDialogHeightResizeModule {}
